module.exports = __webpack_public_path__ + "static/media/be.29c96523.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/be.svg
// module id = 2044
// module chunks = 0